import type {Theme} from '@material-ui/core';

const styles = (theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.common.white,
        height: '100vh',
    },
    rootWithProgress: {
        height: 'calc(100vh - 4px)',
    },
    // lock the page to the visible viewport (dvh excludes mobile browser chrome) so it never scrolls;
    // must be declared after root to override its height
    fitViewport: {
        height: '100dvh',
        fallbacks: [{height: '100vh'}],
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    // desktop left grid column; explicit height because Grid's flex-wrap otherwise sizes the row to its content
    fitViewportColumn: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    // a column that takes the space left under the topbar and lets children shrink into it
    fitViewportContent: {
        flex: '1 1 auto',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    grid: {
        height: '100%',
    },
    content: {
        backgroundColor: theme.palette.common.white,
        paddingTop: '20px',
        // height: '100%',
    },
    listingImageWrapper: {
        overflow: 'hidden',
        width: '100%',
        height: '100%',
    },
    listingImage: {
        // @ts-ignore - neutral exists but is not on Theme type
        backgroundColor: theme.palette.common.neutral,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
    },
    useScroll: {
        maxHeight: '90vh',
        overflow: 'scroll',
        overflowX: 'hidden',
        paddingRight: '10px',
    },
});

export default styles;
